/* @ngInject */
export function MammoQualityControlController($log, NavigationService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        $log.debug('MammoQualityControl::init');
        var navConfig = NavigationService.getNavConfig();
        ctrl.colorName = navConfig.colorName;
        ctrl.icon = navConfig.icon;
    };
}
